import { Component, OnInit } from "@angular/core";
import { locale as italian } from "../../../../../i18n/it";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { CitiesService } from "../../../../../auth/service/cities.service";
import { JobSiteService } from "../../../../../auth/service/job-sites.service";
import { UserFigureService } from "../../../../../auth/service/user-figure.service";
import { EducationTitleService } from "../../../../../auth/service/education-title.service";
import { SkillsService } from "../../../../../auth/service/skills.service";
import { CertificationService } from "../../../../../auth/service/certification.service";
import wolrdLanguages from "../../../../../auth/models/languages";
import { Router } from "@angular/router";
import { CustomerService } from "../../../../../modules/customer/customer.service";
import { AuthenticationService, UserService } from "../../../../../auth/service";
import { RequestService } from "../../request.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-create-request",
  templateUrl: "./create-request.component.html",
  styleUrls: ["./create-request.component.scss"],
})
export class CreateRequestComponent implements OnInit {
  public contentHeader: IContentHeader;
  public formGroup: FormGroup;
  public showErrors: boolean = false;
  public items_skills: Array<any> = [];
  public languages_list: string[] = wolrdLanguages;
  public references_list: any[] = [];
  public filter_references_list: any[] = [];
  public toggleModalAdd: boolean = false;
  public commercialUsers: any = [];

  constructor(
    public _formBuilder: FormBuilder,
    public _utilService: UtilsService,
    public _citiesService: CitiesService,
    public _jobSiteService: JobSiteService,
    public _userFigureService: UserFigureService,
    public _educationTitleService: EducationTitleService,
    public _skillService: SkillsService,
    public _certificationService: CertificationService,
    private _router: Router,
    public customerService: CustomerService,
    public userService: UserService,
    public requestService: RequestService,
    public _authenticationService: AuthenticationService,
  ) {
    this.contentHeader = {
      headerTitle: italian.data.MENU.CREATE_REQUEST,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.RECRUITMENT",
            isLink: false,
          },
          {
            name: "MENU.CUSTOMERS_REQUESTS",
            isLink: true,
            link: "/dashboard/requests-list",
          },
          {
            name: "MENU.CREATE_REQUEST",
            isLink: false,
          },
        ],
      },
    };

    this.formGroup = this._formBuilder.group({
      commercial: new FormControl("", [Validators.required, Validators.min(1)]),
      client: new FormControl("", [Validators.required, Validators.min(1)]),
      referent: new FormControl("", [Validators.required, Validators.min(1)]),
      city: new FormControl("", [Validators.required]),
      site: new FormControl("", [Validators.required]),
      figure: new FormControl([], [Validators.required]),
      description: new FormControl("", [Validators.required, Validators.minLength(2)]),
      education_title: new FormControl(null),
      certifications: new FormControl(""),
      languages: new FormControl(""),
      rate: new FormControl(""),
      priority: new FormControl(""),
    });
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("create_customer_request")) {
      this._utilService.hideLoading();
      this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.addSkillItem();
    await this._certificationService.getList();
    await this._skillService.getList();
    await this._userFigureService.getList();
    await this._educationTitleService.getList();
    await this.customerService.getCustomers();
    this.commercialUsers = await this.userService.getList("employee", "Commerciale,Direzione");
    this.references_list = await this.customerService.getReferents();
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup.controls[field_name].status === "INVALID";
    } else {
      return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
    }
  }

  changeReferentList() {
    this.filter_references_list = this.references_list.filter((item): any => {
      return item.client_id === this.formGroup.value.client;
    });
  }

  setMaxThreeSkillsAsRequested(skill: any, i: number) {
    let totalRequestedSkill = 0;
    this.items_skills.map((skillItem: any) => {
      if (skillItem.requested === true) {
        totalRequestedSkill++;
      }
    });
    if (totalRequestedSkill > 3) {
      if (skill.requested === true) {
        if (i === 0) {
          this.items_skills[i + 1].requested = false;
          return this._utilService.showSWALError({ text: "INSERT_MAX_THREE_REQUESTED_SKILL" });
        } else {
          this.items_skills[i - 1].requested = false;
          return this._utilService.showSWALError({ text: "INSERT_MAX_THREE_REQUESTED_SKILL" });
        }
      }
    }
  }

  addSkillItem() {
    this.items_skills.push({ skill: 0, level: "junior", requested: 0 });
  }

  deleteSkillItem(index: number) {
    delete this.items_skills[index];
    this.items_skills = this.items_skills.filter((i) => i);
  }

  formatRate() {
    this.formGroup.patchValue({
      rate: this._utilService.addDotsToNumber(this.formGroup.value.rate),
    });
  }

  async createRequest() {
    if (!this._authenticationService.hasCapability("create_customer_request")) {
      await this._router.navigateByUrl("dashboard/main");
      return false;
    }

    this.showErrors = true;
    // controllo valori
    if (this.formGroup.invalid) {
      window.scrollTo(0, 0);
      return false;
    }

    if (this.items_skills && this.items_skills.length < 1) {
      await this._utilService.showSWALError({ text: "ERROR_SKILLS_LIST_EMPTY" });
      return false;
    }
    //check duplicate skills
    const checkedArray = this.items_skills.reduce((unique, o) => {
      if (!unique.some((obj) => obj.skill === o.skill)) {
        unique.push(o);
      }

      return unique;
    }, []);
    if (this.items_skills.length !== checkedArray.length) {
      await this._utilService.showSWALError({ text: "ERROR_DUPLICATE_SKILL" });
      return false;
    }
    // END check duplicate skills
    let data = this.formGroup.value;
    const figures = this.formGroup.value.figure;
    data.figure = figures[0];
    data.figure2 = figures[1] ? figures[1] : null;
    data.priority = data.priority ? 1 : 0;
    data.skills = this.items_skills.filter((item: any) => item.skill != 0);

    if (data.skills.length == 0) {
      await this._utilService.showSWALError({ text: "SELECT_AT_LEAST_ONE_SKILL" });
      return false;
    }

    if (data.skills) {
      data.skills.map((item: any) => {
        item.requested = Number(item.requested);
      });
    }

    if (data.skills.filter((itemSkill: any) => Boolean(itemSkill.requested)).length == 0) {
      await this._utilService.showSWALError({ text: "SELECT_AT_LEAST_ONE_REQUESTED_SKILL" });
      return false;
    }

    if (!data.certifications) {
      data.certifications = [];
    }
    if (!data.languages) {
      data.languages = [];
    }
    if (!data.education_title) {
      delete data.education_title;
    }

    this._utilService.showLoading();
    await this.requestService
      .createRequest(data)
      .then(async (response: any) => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_CREATE_CUSTOMER_REQUEST" });
        await this._router.navigateByUrl(`dashboard/detail-request/${response.id}`);
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_CREATE_CUSTOMER_REQUEST" });
      });
  }

  async onReferentModalFormEvent(ref: any) {
    if (!this._authenticationService.hasCapability("create_customer_referent")) {
      await this._router.navigateByUrl("dashboard/main");
      return false;
    }
    this.references_list = await this.customerService.getReferents();
    const newReferent: any = this.references_list.find((referent: any) => Number(referent.id) === Number(ref.id));
    setTimeout(() => {
      this.formGroup.patchValue({
        client: newReferent.client_id,
      });
      this.changeReferentList();
      this.formGroup.patchValue({
        referent: newReferent.id,
      });
    });
  }
}
